var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 23 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yt7dub4jka"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 786",
    style: {
      fill: "none"
    },
    d: "M0 0h14.132v14.526H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 198",
    transform: "translate(.909 .656)",
    style: {
      clipPath: "url(#yt7dub4jka)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 581",
    d: "M15.742 12.033a.292.292 0 0 1-.206-.5l2.775-2.773-2.775-2.775a.292.292 0 0 1 .413-.412l2.981 2.981a.292.292 0 0 1 0 .413l-2.981 2.981a.291.291 0 0 1-.206.085",
    transform: "translate(-5.947 -1.497)",
    style: {
      fill: "#13249f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 583",
    d: "M14.448 11.458h-7.6a.292.292 0 1 1 0-.583h7.6a.292.292 0 1 1 0 .583",
    transform: "translate(-1.973 -3.904)",
    style: {
      fill: "#13249f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 585",
    d: "M6.746 12.6H.492a.292.292 0 0 1-.292-.295V.492A.292.292 0 0 1 .492.2h6.254a.292.292 0 1 1 0 .583H.784v11.231h5.962a.292.292 0 1 1 0 .583",
    transform: "translate(.864 .864)",
    style: {
      fill: "#13249f"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c61bf86825e4bd45956894f168986d97.svg";
export { ForwardRef as ReactComponent };